import React from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import ChatModal from "../Orders/components/ChatModal";
import localeText from "../../../../locale";

const OrderDetailsDialogs = ({
  loading,
  confirmReceivedVisible,
  confirmSendVisible,
  currentOrder,
  parcelInfo,
  shippingCompany,
  trackingObject,
  setConfirmReceivedVisible,
  setConfirmSendVisible,
  setShippingCompany,
  setTrackingObject,
  receiveOrder,
  sendOrder,
  isVisibleChat,
  onCloseChat,
}) => {
  return (
    <>
      {currentOrder && isVisibleChat && (
        <ChatModal
          isVisible={isVisibleChat}
          setNotVisibleChat={onCloseChat}
          currentOrder={currentOrder}
        />
      )}

      <ConfirmDialog
        visible={confirmReceivedVisible}
        onHide={() => setConfirmReceivedVisible(false)}
        message={() => (
          <>
            {loading ? (
              <div className="text-center">
                <i className="pi pi-spin pi-spinner text-8xl text-500 my-6" />
              </div>
            ) : (
              <>
                {currentOrder && !currentOrder?.itens?.[0]?.product?.downloadable ? (
                  <>
                    {localeText(
                      currentOrder?.pickinaddress
                        ? "youconfirmOrderWasSent"
                        : "receiveThisOrder",
                    )}
                  </>
                ) : (
                  <>{localeText("receiveDownloadLinksConfirmation")}</>
                )}
              </>
            )}
          </>
        )}
        header={localeText("confirmYourAction")}
        icon="pi pi-exclamation-triangle"
        accept={() => receiveOrder(currentOrder.buyer.username, currentOrder.id)}
        reject={() => setConfirmReceivedVisible(false)}
        acceptLabel={localeText("confirm")}
        rejectLabel={localeText("cancel")}
      />

      <ConfirmDialog
        visible={confirmSendVisible}
        onHide={() => setConfirmSendVisible(false)}
        message={() => (
          <>
            {loading ? (
              <div className="text-center">
                <i className="pi pi-spin pi-spinner text-8xl text-500 my-6" />
              </div>
            ) : (
              <>
                {currentOrder?.itens?.[0]?.product?.subCategory?.service ? (
                  <p>{localeText("confirmOrderWasSent2")}</p>
                ) : (
                  <>
                    {localeText("confirmOrderWasSent")}
                    <ul className="list-none mx-0 mt-4 p-0">
                      <li>
                        <label htmlFor="shipping">{localeText("shippingCompany")}:</label>
                      </li>
                      <li>
                        <InputText
                          className="mt-2 w-full"
                          name="shipping"
                          value={shippingCompany}
                          disabled={!!parcelInfo?.courier}
                          onChange={(e) => setShippingCompany(e.target.value)}
                        />
                      </li>
                      <li className="mt-2">
                        <label htmlFor="tracking">{localeText("trackingObject")}:</label>
                      </li>
                      <li>
                        <InputText
                          className="mt-2 w-full"
                          name="tracking"
                          value={trackingObject}
                          disabled={!!parcelInfo?.shipping_code}
                          onChange={(e) => setTrackingObject(e.target.value)}
                        />
                      </li>
                    </ul>
                  </>
                )}
              </>
            )}
          </>
        )}
        header={localeText("sendOrder")}
        icon="pi pi-exclamation-triangle"
        accept={() => {
          sendOrder(
            localStorage.getItem("__extraconomy_username"),
            currentOrder.id,
            shippingCompany,
            trackingObject,
          );
        }}
        reject={() => setConfirmSendVisible(false)}
        acceptLabel={localeText("confirm")}
        rejectLabel={localeText("cancel")}
      />
    </>
  );
};

export default OrderDetailsDialogs;

